import { render, staticRenderFns } from "./lightRate.vue?vue&type=template&id=428ca2ed&scoped=true"
import script from "./lightRate.vue?vue&type=script&lang=js"
export * from "./lightRate.vue?vue&type=script&lang=js"
import style0 from "./lightRate.vue?vue&type=style&index=0&id=428ca2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ca2ed",
  null
  
)

export default component.exports